import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReportItemShareRequestDto, ReportViewEntity, ReportViewUpsertRequestDto } from '../../../../reporting.model';
import { ReportKey } from '../../../../reports/report.registry';

@Injectable({
    providedIn: 'root'
})
export class ReportViewService {
    private httpClient = inject(HttpClient);

    get(reportKey: ReportKey, subscriberKey: number | null): Observable<ReportViewEntity[]> {
        return this.httpClient.get<ReportViewEntity[]>(`api/common/reports/${reportKey}/views`, {
            params: this.getSubscriberParams(subscriberKey)
        });
    }

    create(reportKey: ReportKey, reportView: ReportViewUpsertRequestDto): Observable<number> {
        return this.httpClient.post<number>(`api/common/reports/${reportKey}/views`, reportView);
    }

    update(reportKey: ReportKey, viewKey: number, reportView: ReportViewUpsertRequestDto): Observable<number> {
        return this.httpClient.put<number>(`api/common/reports/${reportKey}/views/${viewKey}`, reportView);
    }

    share(reportKey: ReportKey, viewKey: number, subscriberKey: number | null, recipientUserId: string): Observable<number> {
        const request: ReportItemShareRequestDto = { recipientUserId };
        return this.httpClient.post<number>(`api/common/reports/${reportKey}/views/${viewKey}/share`, request, {
            params: this.getSubscriberParams(subscriberKey)
        });
    }

    delete(reportKey: ReportKey, viewKey: number, subscriberKey: number | null): Observable<void> {
        return this.httpClient.delete<void>(`api/common/reports/${reportKey}/views/${viewKey}`, {
            params: this.getSubscriberParams(subscriberKey)
        });
    }

    private getSubscriberParams(subscriberKey: number | null): HttpParams {
        let params = new HttpParams();
        if (subscriberKey != null) {
            params = params.set('subscriberKey', subscriberKey);
        }

        return params;
    }
}
